var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.492 0c5.805 0 10.511 4.701 10.511 10.5S18.297 21 12.493 21c-4.352 0-8.085-2.64-9.683-6.405l.897-.449A9.51 9.51 0 0 0 12.492 20c5.253 0 9.51-4.253 9.51-9.5S17.746 1 12.493 1a9.51 9.51 0 0 0-9.125 6.813l3.455-1.395a.5.5 0 0 1 .61.196l.04.08a.5.5 0 0 1-.276.651L2.56 9.218a.5.5 0 0 1-.65-.276L.035 4.306a.5.5 0 1 1 .928-.375l1.448 3.585A10.51 10.51 0 0 1 12.492 0m.016 4a.5.5 0 0 1 .5.5v5.84l4.096 4.096a.5.5 0 1 1-.708.708l-4.242-4.242a.5.5 0 0 1-.146-.368l-.001-.035V4.501a.5.5 0 0 1 .5-.501z"
  })));
});
const SvgVersionControlIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVersionControlIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMyAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMi40OTIgMGM1LjgwNSAwIDEwLjUxMSA0LjcwMSAxMC41MTEgMTAuNVMxOC4yOTcgMjEgMTIuNDkzIDIxYy00LjM1MiAwLTguMDg1LTIuNjQtOS42ODMtNi40MDVsLjg5Ny0uNDQ5QTkuNTE0IDkuNTE0IDAgMCAwIDEyLjQ5MiAyMGM1LjI1MyAwIDkuNTEtNC4yNTMgOS41MS05LjVTMTcuNzQ2IDEgMTIuNDkzIDFhOS41MTMgOS41MTMgMCAwIDAtOS4xMjUgNi44MTNsMy40NTUtMS4zOTVhLjUuNSAwIDAgMSAuNjEuMTk2bC4wNC4wOGEuNS41IDAgMCAxLS4yNzYuNjUxTDIuNTYgOS4yMThhLjUuNSAwIDAgMS0uNjUtLjI3NkwuMDM1IDQuMzA2YS41LjUgMCAxIDEgLjkyOC0uMzc1bDEuNDQ4IDMuNTg1QTEwLjUxNCAxMC41MTQgMCAwIDEgMTIuNDkyIDB6bS4wMTYgNGEuNS41IDAgMCAxIC41LjV2NS44NGw0LjA5NiA0LjA5NmEuNS41IDAgMSAxLS43MDguNzA4bC00LjI0Mi00LjI0MmEuNS41IDAgMCAxLS4xNDYtLjM2OC43Mi43MiAwIDAgMS0uMDAxLS4wMzVWNC41MDFhLjUuNSAwIDAgMSAuNS0uNTAxeiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";